import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { ModalLayout } from 'layouts/ModalLayout/ModalLayout';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useActions, useAppDispatch, useAppSelector } from 'hooks';
import { notificationActions, notificationSelect, notificationThunk } from 'state';
import styles from './NotificationModal.module.scss';
import { Warning } from 'assets';

interface INotificationModalProps {
  setNotificationModal: (value: boolean) => void;
  isEdit?: boolean;
}

export const NotificationModal = ({
  setNotificationModal,
  isEdit,
}: INotificationModalProps) => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('GP/Emergency doctor');
  const [bodyMessage, setBodyMessage] = useState('');
  const [bodyMessageArabic, setBodyMessageArabic] = useState('');
  const { getNotifications, createNotification, updateNotification } =
    useActions(notificationThunk);
  const [isEnglish, setIsEnglish] = useState(true);
  const [isWarning, setWarning] = useState(false);
  const notification: any = useAppSelector(notificationSelect);
  const dispatch = useAppDispatch();
  const [isWarningArabic, setWarningArabic] = useState(false);

  useEffect(() => {
    if (notification) {
      setBodyMessage(notification.contentEnglish);
      setBodyMessageArabic(notification.contentArabic);
      setSelectedCategory(notification.category);
    }
  }, [notification]);

  const handleChangeLanguage = () => {
    setIsEnglish(!isEnglish);
  };

  const handleAdd = () => {
    const isArabic = /^[\u0600-\u06FF\u0660-\u0669\u0030-\u0039\s!@#\$%\^\&*\)\(+=._-]+$/;

    console.log('handleAdd');
    if (!bodyMessage || !bodyMessageArabic) {
      setWarning(true);
      return;
    } else {
      setWarning(false);
    }

    if (!isArabic.test(bodyMessageArabic)) {
      setWarningArabic(true);
      return;
    }

    const data = {
      doctorCategories: selectedCategory,
      contentEnglish: bodyMessage,
      contentArabic: bodyMessageArabic,
    };

    setSelectedCategory('GP/Emergency doctor');
    setBodyMessage('');
    isEdit ? updateNotification({ id: notification.id, data }) : createNotification(data);
    setNotificationModal(false);
    dispatch(notificationActions.clearNotification());
  };

  const handleClose = () => {
    setNotificationModal(false);
    setSelectedCategory('GP/Emergency doctor');
    setBodyMessage('');
    dispatch(notificationActions.clearNotification());
  };

  return (
    <ModalLayout handleClose={handleClose} title={'Create Notification'}>
      <div className={styles.radiobuttonContainer}>
        <button
          type="button"
          // `aria-pressed` rather than a bare button: these two are a pair
          // showing which language the body below is being written in, and
          // without it a screen reader announces two identical buttons with no
          // way to tell which one is currently active.
          aria-pressed={isEnglish}
          onClick={handleChangeLanguage}
          className={isEnglish ? styles.checkedLanguage : styles.uncheckedLanguage}
        >
          English
        </button>
        <button
          type="button"
          aria-pressed={!isEnglish}
          onClick={handleChangeLanguage}
          className={!isEnglish ? styles.checkedLanguage : styles.uncheckedLanguage}
        >
          Arabic
        </button>
      </div>

      <div>
        <p>User type</p>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Category</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedCategory}
            label="Category"
            onChange={e => {
              setSelectedCategory(e.target.value);
            }}
          >
            <MenuItem value={'GP/Emergency doctor'}>GP/Emergency doctor</MenuItem>
            <MenuItem value={'Specialist doctor'}>Specialist doctor</MenuItem>
            <MenuItem value={'Nurse'}>Nurse</MenuItem>
            <MenuItem value={'Consultant doctor'}>Consultant doctor</MenuItem>
            <MenuItem value={'Physio therapist'}>Physio therapist</MenuItem>
            <MenuItem value={'Patient'}>Patient</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div>
        <p>Notification body</p>
        <textarea
          maxLength={200}
          className={styles.notificationModalTextarea}
          value={isEnglish ? bodyMessage : bodyMessageArabic}
          onChange={(e: any) => {
            isEnglish
              ? setBodyMessage(e.target.value)
              : setBodyMessageArabic(e.target.value);
          }}
        />
      </div>

      {isWarning && (
        <div className={styles.warningContainer}>
          <Warning />
          <div className={styles.warningText}>Both languages ​​must be filled in</div>
        </div>
      )}

      {isWarningArabic && (
        <div className={styles.warningContainer}>
          <Warning />
          <div className={styles.warningText}>The message must be in Arabic</div>
        </div>
      )}

      <button type="button" className="button-dark" onClick={handleAdd}>
        {isEdit ? 'Save' : 'Add'}
      </button>
    </ModalLayout>
  );
};
